import {railsPartialQuery} from '@github-ui/react-core/future/rails-partial-query'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {pullRequestsAppBuilder} from '../config/app-builder'

export function buildPullRequestsChecksRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsChecksRoute', {
    path: '/:owner/:repo/pull/:pr_number/checks',
    queries: [
      railsPartialQuery({
        partialName: 'Main',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/checks_partial`}
        },
      }),
    ],
    index: true,
  })
}

export const pullRequestsChecksRoute = buildPullRequestsChecksRoute(pullRequestsAppBuilder)
